export default function SentIcon() {
  return (
    <svg width='40' height='41' viewBox='0 0 40 41' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.5' width='40' height='40' rx='20' fill='currentColor' fillOpacity='0.1' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2928 20.2068C13.1053 20.0193 13 19.765 13 19.4998C13 19.2346 13.1053 18.9803 13.2928 18.7928L19.2928 12.7928C19.4803 12.6053 19.7346 12.5 19.9998 12.5C20.265 12.5 20.5193 12.6053 20.7068 12.7928L26.7068 18.7928C26.8889 18.9814 26.9897 19.234 26.9875 19.4962C26.9852 19.7584 26.88 20.0092 26.6946 20.1946C26.5092 20.38 26.2584 20.4852 25.9962 20.4875C25.734 20.4897 25.4814 20.3889 25.2928 20.2068L20.9998 15.9138V27.4998C20.9998 27.765 20.8944 28.0194 20.7069 28.2069C20.5194 28.3944 20.265 28.4998 19.9998 28.4998C19.7346 28.4998 19.4802 28.3944 19.2927 28.2069C19.1051 28.0194 18.9998 27.765 18.9998 27.4998V15.9138L14.7068 20.2068C14.5193 20.3943 14.265 20.4996 13.9998 20.4996C13.7346 20.4996 13.4803 20.3943 13.2928 20.2068Z'
        fill='currentColor'
      />
    </svg>
  )
}
